export const PERMISSION_ADMIN = 'admin';
export const PERMISSION_COMPANY_ADMIN = 'CompanyAdmin';
export const PERMISSION_EMPLOYEE = 'Employee';

export const PERMISSION_ALL = [ PERMISSION_ADMIN ];
